import { useState } from 'react';
import { faqs } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            你可能想问的
          </h2>
          <p className="text-foreground-500 text-sm">
            这里汇总了寸止挑战最常被问到的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h3 className="font-semibold text-foreground-900 text-sm pr-4">{faq.question}</h3>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === i ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-400'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}